module.exports = __webpack_public_path__ + "img/adorno-3.04ffde9c.png";